module.exports = __webpack_public_path__ + "img/amentum-logo.6a7a4668.svg";